import { GETAMAZONBOOKS, GETCHEGGBOOKS } from "../constants/actionTypes";

export default (webbooks = [], action) =>{
    switch (action.type){
        case GETAMAZONBOOKS:
            return action.payload;
        case GETCHEGGBOOKS:
            return action.payload;
        default:
            return webbooks;      
    }
}